module.exports = __webpack_public_path__ + "img/parking.bb7eb335.svg";